const ADMIN_SETTINGS_SECTIONS = [
  'organization',
  'team',
  'shipping',
  'shipping-international',
  'shipping-packages',
  'shipping-locations',
  'shipping-accounts',
  'shipping-tags',
  'shipping-printing',
  'marketplace-apps',
  'payment-gateways',
  'media-generation',
  'research-tools',
  'apple-push',
  'etsy-listing',
  'partner-api',
  'partner-catalog',
  'referral-program',
  'referral-referrals',
  'referral-ledger',
  'referral-cost',
  'login-experience',
  'catalog-brand',
  'policies',
  'review-tracking',
  'users',
  'notifications',
  'messaging',
  'problem-reporting',
  'inventory-rollout',
  'view-as',
  'security',
  'appearance',
  'drive-maintenance',
  'demo-guide',
  'resources',
] as const

export type AdminSettingsSectionId = (typeof ADMIN_SETTINGS_SECTIONS)[number]

const SECTION_IDS = new Set<string>(ADMIN_SETTINGS_SECTIONS)

export function resolveAdminSettingsSection(search: string): AdminSettingsSectionId {
  const requested = new URLSearchParams(search).get('section')
  if (requested === 'team') return 'users'
  // The Shipping rail entry opens on its first tab (2026-10-06).
  if (requested === 'shipping') return 'shipping-accounts'
  // Carriers and Rate Shopper merged into the Shipping providers hub.
  if (requested === 'shipping-carriers' || requested === 'shipping-rate-shopper') {
    return 'shipping-accounts'
  }
  return requested && SECTION_IDS.has(requested)
    ? (requested as AdminSettingsSectionId)
    : 'organization'
}

// Sections that left Settings for a main-menu page (2026-10-05). An old
// `?section=` link to one of them is sent on to its new address.
const MOVED_TO_MAIN_MENU: Record<string, string> = {
  'supplier-hub': '/admin/catalog/suppliers',
  drive: '/admin/drive-audit',
  // Personal, not company settings (2026-10-06): permissions became a tab of
  // the account page, and the account Profile already sets the language.
  'my-permissions': '/admin/account?tab=permissions',
  languages: '/admin/account',
}

export function movedAdminSettingsSectionTarget(search: string): string | null {
  const requested = new URLSearchParams(search).get('section')
  return requested ? MOVED_TO_MAIN_MENU[requested] ?? null : null
}
